import { createFileRoute } from "@tanstack/react-router";
import BcbsmsInsurance, { config } from "@/pages/BcbsmsInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/bcbsms-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Mississippi TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield Mississippi coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "BCBS Mississippi TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield Mississippi coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbsms-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbsms-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbsmsInsurance />;
}
